export default __webpack_public_path__ + "static/project-slide-5-992-765-523ef57f3003466142cd2958c08cd189.jpg";